import { render, staticRenderFns } from "./arinvrealisasifrm.vue?vue&type=template&id=2b740fca"
import script from "./arinvrealisasifrm.vue?vue&type=script&lang=js"
export * from "./arinvrealisasifrm.vue?vue&type=script&lang=js"
import style0 from "./arinvrealisasifrm.vue?vue&type=style&index=0&id=2b740fca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports